import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { getCookie, setStalkerBannerCookie, STALKER_BANNER_COOKIE } from '../utils';

export enum EStalkerBannerActions {
  show = 'registrationTriggers/stalkerBanner/show',
  hide = 'registrationTriggers/stalkerBanner/hide',
}

export interface IShowStalkerBanner {
  type: EStalkerBannerActions.show;
}

export interface IHideStalkerBanner {
  type: EStalkerBannerActions.hide;
}

export function showStalkerBanner(): IShowStalkerBanner {
  return {
    type: EStalkerBannerActions.show,
  };
}

export function hideStalkerBanner(): IHideStalkerBanner {
  return {
    type: EStalkerBannerActions.hide,
  };
}

export function showLoginPopup() {
  return (dispatch: Dispatch<IState>) => {
    dispatch(hideStalkerBanner());

    if (window.waitForLoginPopup) {
      window.waitForLoginPopup();
    }
  };
}

export function closeBanner() {
  return (dispatch: Dispatch<IState>) => {
    dispatch(hideStalkerBanner());

    if (!getCookie(STALKER_BANNER_COOKIE)) {
      setStalkerBannerCookie();
    }
  };
}
